module.exports = __webpack_public_path__ + "img/DS423.9018b1d9.png";